/* tslint:disable */
/* eslint-disable */
/**
 * backend/api/v2beta1/run.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Describes the state of a plugin's operations.
 * Unlike RuntimeState (which covers pipeline/task lifecycle including CANCELING,
 * PAUSED, SKIPPED), PluginState only reflects whether the plugin's own work
 * succeeded or failed, independent of the pipeline run outcome.
 *
 *  - PLUGIN_STATE_UNSPECIFIED: Default value. The plugin state is unknown or not yet set.
 *  - PLUGIN_RUNNING: Plugin operations are in progress.
 *  - PLUGIN_SUCCEEDED: Plugin operations completed successfully.
 *  - PLUGIN_FAILED: Plugin operations failed.
 * @export
 */
export const V2beta1PluginState = {
  PLUGIN_STATE_UNSPECIFIED: 'PLUGIN_STATE_UNSPECIFIED',
  PLUGIN_RUNNING: 'PLUGIN_RUNNING',
  PLUGIN_SUCCEEDED: 'PLUGIN_SUCCEEDED',
  PLUGIN_FAILED: 'PLUGIN_FAILED',
} as const;
export type V2beta1PluginState = (typeof V2beta1PluginState)[keyof typeof V2beta1PluginState];

export function instanceOfV2beta1PluginState(value: any): boolean {
  for (const key in V2beta1PluginState) {
    if (Object.prototype.hasOwnProperty.call(V2beta1PluginState, key)) {
      if (V2beta1PluginState[key as keyof typeof V2beta1PluginState] === value) {
        return true;
      }
    }
  }
  return false;
}

export function V2beta1PluginStateFromJSON(json: any): V2beta1PluginState {
  return V2beta1PluginStateFromJSONTyped(json, false);
}

export function V2beta1PluginStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V2beta1PluginState {
  return json as V2beta1PluginState;
}

export function V2beta1PluginStateToJSON(value?: V2beta1PluginState | null): any {
  return value as any;
}

export function V2beta1PluginStateToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): V2beta1PluginState {
  return value as V2beta1PluginState;
}
